import React from 'react';
import {Breadcrumbs} from '../breadcrumbs/breadcrumbs';
import i18n from './../../utilities/i18n';
import {ErrorBox} from '../errorbox/errorbox';
import '../ugyldigjeger/ugyldigjeger.scss';

export const UmyndigJeger = () => {
  return (
    <div className='container errorBoxMargin'>
      <article className='pagetitle'>
        <Breadcrumbs crumbKey="lisensjeger" title={i18n.t('felles:lisensjeger')}/>
        <h1>{i18n.t('titel:hovedTitel')}</h1>
      </article>
      <ErrorBox>
        <h3>{i18n.t('serverError:forUng')}</h3>
      </ErrorBox>
    </div>
  );
};
